import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-521698aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-md font-bold flex" }, "Upload files", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-md flex text-gray-500" }, " Upload the documents that are associated with the employment relationship, such as the resume, contract, etc. ", -1))
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = ["onchange"]
const _hoisted_6 = {
  key: 0,
  class: "relative h-full w-full flex flex-col justify-center items-center animate__animated animate__fadeIn animate__delay-0.6s"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-14 w-14 text-primary mb-2\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-521698aa><polyline points=\"16 16 12 12 8 16\" data-v-521698aa></polyline><line x1=\"12\" y1=\"12\" x2=\"12\" y2=\"21\" data-v-521698aa></line><path d=\"M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3\" data-v-521698aa></path><polyline points=\"16 16 12 12 8 16\" data-v-521698aa></polyline></svg><span class=\"text-gray-500 font-medium text-base\" data-v-521698aa>Drag your files here</span><span class=\"text-gray-500 font-mediu\" data-v-521698aa>OR</span><span class=\"bg-primary text-white px-5 py-3 rounded-3xl cursor-pointer font-medium\" data-v-521698aa>Browse file</span>", 4)
const _hoisted_11 = [
  _hoisted_7
]
const _hoisted_12 = {
  key: 0,
  class: "w-full mt-2 p-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 font-semibold pb-2 border-b-2 w-full" }, " Files uploaded ", -1))
const _hoisted_14 = { class: "flex flex-row justify-between items-center space-y-3 p-2" }
const _hoisted_15 = { class: "mr-2" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "flex flex-col w-full" }
const _hoisted_18 = { class: "text-sm text-gray-600 font-medium" }
const _hoisted_19 = { class: "text-xs uppercase text-gray-500 leading-4" }
const _hoisted_20 = { class: "flex flex-row space-x-3" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6 text-green-500",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("polyline", { points: "20 6 9 17 4 12" })
  ])
], -1))
const _hoisted_25 = { class: "flex flex-row justify-between mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["h-64 relative rounded-2xl p-8 shadow", 
          _ctx.fileName
            ? 'input-file-content bg-gray-100 border-2 border-purple-400 '
            : 'input-file'
        ])
      }, [
        _createElementVNode("input", {
          class: "opacity-0 z-20 absolute w-full top-0 bottom-0 -ml-8 appearance-none cursor-pointer",
          name: "file",
          id: "entry_value",
          ref: "fileInput",
          type: "file",
          accept: ".jpg, .jpeg, .png, .pdf, .xlsx, .xls, .doc, .docx, .odt",
          onchange: _ctx.addFile
        }, null, 8, _hoisted_5),
        (!_ctx.fileName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_11))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (_ctx.files.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "stripe px-2 mt-2",
              key: index
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: _ctx.getFileIcon(_ctx.getFileExtension(file.name)),
                    alt: ""
                  }, null, 8, _hoisted_16)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(file.name), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.getFileExtension(file.name)), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.deleteFile(index)),
                    class: "cursor-pointer"
                  }, _hoisted_23, 8, _hoisted_21),
                  _hoisted_24
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_Button, {
        variant: "outlined",
        label: "Cancel",
        onClick: _ctx.closeInForm
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        variant: "contained",
        disabled: _ctx.files.length <= 0 || _ctx.isLoading,
        label: "Upload files",
        onClick: _ctx.uploadFiles
      }, null, 8, ["disabled", "onClick"])
    ])
  ]))
}